import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { QualityRadioGroupOptions, QualityRadioGroupRoot, QualityRadioGroupValue } from "./component.js";
//#region src/ui/quality-radio-group/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Options: () => QualityRadioGroupOptions,
	Root: () => QualityRadioGroupRoot,
	Value: () => QualityRadioGroupValue
});
//#endregion
export { QualityRadioGroupOptions as Options, QualityRadioGroupRoot as Root, QualityRadioGroupValue as Value, index_parts_exports };

//# sourceMappingURL=index.parts.js.map